import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['show', 'hide', 'sidebar', 'container', 'submitInfo'];
  static values = {
    standalone: Boolean,
  };

  initialize() {
    this.showing = true;
  }

  toggle() {
    this.hideTargets.forEach((el) => {
      el.classList.toggle('hidden');
    });
    this.showTargets.forEach((el) => {
      el.classList.toggle('hidden');
    });
    this.sidebarTarget.classList.toggle('collapsed');
    if (this.hasContainerTarget) {
      this.containerTarget.classList.toggle('instructions-collapsed');
    }
    this.showing = !this.showing;
    if (this.showing) {
      this.instructionsWindow?.close();
    }
  }

  hide() {
    this.hideTarget.classList.add('hidden');
    this.showTarget.classList.remove('hidden');
    this.sidebarTarget.classList.add('collapsed');
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add('instructions-collapsed');
    }
    this.showing = false;
  }

  show() {
    this.hideTarget.classList.remove('hidden');
    this.showTarget.classList.add('hidden');
    this.sidebarTarget.classList.remove('collapsed');
    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove('instructions-collapsed');
    }
    this.showing = true;
    this.clearPopup();
  }

  clearPopup() {
    this.instructionsWindow?.close();
    this.instructionsWindow = null;
  }

  message(event) {
    if (!this.standaloneValue) {
      if (event.source === this.instructionsWindow) {
        if (this[event.data]) {
          this[event.data]();
        } else {
          console.log('Unknown message:', event.data);
        }
      }
    }
  }

  showOverview() {
    if (this.standaloneValue) {
      window.opener.postMessage('showOverview', '*');
    } else {
      this.dispatch('showOverview');
    }
  }

  relaunch() {
    if (this.standaloneValue) {
      window.opener.postMessage('relaunch', '*');
    } else {
      this.dispatch('relaunch');
    }
  }

  confirmSubmit() {
    if (this.hasSubmitInfoTarget) {
      this.submitInfoTarget.showModal();
    }
    if (this.standaloneValue) {
      window.opener.postMessage('confirmSubmit', '*');
    } else {
      this.dispatch('confirmSubmit');
    }
  }

  showGrades() {
    if (this.standaloneValue) {
      window.opener.postMessage('showGrades', '*');
    } else {
      this.dispatch('showGrades');
    }
  }

  showRubric() {
    if (this.standaloneValue) {
      window.opener.postMessage('showRubric', '*');
    } else {
      this.dispatch('showRubric');
    }
  }

  popin() {
    if (this.standaloneValue) {
      window.opener.postMessage('popin', '*');
    } else {
      this.show();
    }
  }

  popout(event) {
    this.hide();
    this.showTarget.classList.add('hidden');
    this.instructionsWindow = window.open(
      event.currentTarget.dataset.target,
      'instructions',
      'top=0,left=0,width=600,height=800,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
    );
  }
}
